import * as Yup from "yup";
import { t } from "@lingui/macro";

const createSchema = () =>
  Yup.object().shape({
    all_clients: Yup.boolean(),
    client_ids: Yup.array()
      .of(Yup.number())
      .when("all_clients", {
        is: false,
        then: Yup.array()
          .of(Yup.number())
          .min(1, t`Select at least one client`)
          .required(t`Select at least one client`),
        otherwise: Yup.array().of(Yup.number()).nullable(),
      }),
    date_start: Yup.string()
      .nullable()
      .required(t`Start date is required`),
    date_end: Yup.string()
      .nullable()
      .required(t`End date is required`)
      .test(
        "after-start",
        t`End date must be on or after the start date`,
        function (value) {
          const start = this.parent?.date_start;
          if (!value || !start) return true;
          return new Date(value) >= new Date(start);
        },
      ),
  });

export default createSchema;
